import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from 'services/authService';

interface AuthPageGuardProps {
  children: React.ReactElement;
}

/**
 * AuthPageGuard component prevents authenticated users from accessing auth pages (sign-in, sign-up).
 * If a user is already logged in and tries to access these pages, they will be redirected to the admin dashboard.
 */
const AuthPageGuard = ({ children }: AuthPageGuardProps) => {
  const navigate = useNavigate();

  useEffect(() => {
    const isAuthenticated = authService.isAuthenticated();
    
    if (isAuthenticated) {
      // User is already logged in, redirect to admin dashboard
      navigate('/admin/dashboard', { replace: true });
    }
  }, [navigate]);

  // If not authenticated, render the auth page (sign-in or sign-up)
  return children;
};

export default AuthPageGuard;
